
export const chartStyles = {
    axisLine: {
        color: '#888',
        width: 2,
    },
    axisLabel: {
        fontSize: 12,
        fontFamily: 'Roboto, Arial, sans-serif',
        color: '#222',
        fontWeight: 500,
    },
    axisNameText: {
        fontSize: 16,
        fontWeight: 600,
        color: '#222',
    },
    legendText: {
        fontSize: 14,
        fontFamily: 'Roboto, Arial, sans-serif',
        color: '#222',
        fontWeight: 400,
    },
};
